import React from "react"

const ANyAppPrivacy = () => {
  return (
    <div className="policy ">
      <div className="text-info">

    <h2 class="textcolor">1. Our Pledge to Privacy</h2>
    We hold your privacy in high regard, and this policy outlines our firm commitment to preserving and protecting it.
    <h2 class="textcolor">2. Handling of Data and Purpose</h2>
    We maintain a stringent policy of abstaining from collecting, retaining, or utilizing any personal or usage data when you interact with our application. Our foremost aim is to provide you with a functional and secure experience without accessing or storing any of your personal information.
    <h2 class="textcolor">3. Third-Party Involvement</h2>
    Although we do not collect data ourselves, it's important to acknowledge that our application may include links to third-party websites or utilize third-party services (such as app store platforms or analytics tools) that might gather data about you. We advise reviewing their privacy policies to understand their practices.
    <h2 class="textcolor">4. Updates to This Privacy Policy</h2>
    From time to time, we may revise this Privacy Policy to align with changes in our procedures or for other operational, legal, or regulatory purposes. Any amendments will be communicated on this page along with an updated "Last Modified" date.
      </div>
</div>
  )
}

export default ANyAppPrivacy
